import {cloneElement, useMemo} from 'react'
import {FloatingPortal, useMergeRefs, FloatingArrow} from '@floating-ui/react'
import {TooltipProvider, useTooltipContext} from './tooltip_context'
import {TooltipText} from './tooltip_text'
import {Layout} from '../layout'

import './styles/index.less'

export const Tooltip = ({trigger, t, text}) => {
	return (
		<TooltipProvider>
			<TooltipTrigger trigger={trigger} />
			<TooltipContent>
				<TooltipText t={t} text={text} />
			</TooltipContent>
		</TooltipProvider>
	)
}

const TooltipTrigger = ({trigger, ...rest}) => {
	const {refs, getReferenceProps} = useTooltipContext()
	const mergedRefs = useMemo(() => [refs.setReference, trigger.props.ref], [refs.setReference, trigger.props.ref])
	const ref = useMergeRefs(mergedRefs)

	const referenceProps = getReferenceProps({
		...trigger.props, // includes dnd-kit listeners/attributes from parent
		...rest,
		ref,
	})

	return cloneElement(trigger, {ref, ...referenceProps})
}

const TooltipContent = ({children, ...rest}) => {
	const {arrowRef, isOpen, refs, floatingStyles, getFloatingProps, context} = useTooltipContext()

	if (!isOpen) return null

	const floatingProps = getFloatingProps(rest)

	return (
		<FloatingPortal>
			<Layout
				className="tooltip"
				ref={refs.setFloating}
				style={floatingStyles}
				maxWidth={500}
				background="tooltip"
				padding="8"
				borderRadius
				colorSet={false}
				baseColor={null}
				{...floatingProps}
			>
				{children}
				<FloatingArrow ref={arrowRef} context={context} />
			</Layout>
		</FloatingPortal>
	)
}
